import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Config from '../../../helpers/Config';
import BannerSlider from '../../components/home/BannerSlider';
import PopularCategories from '../../components/shared/PopularCategories';
import DiscountBannerOmg from '../../components/shared/DiscountBannerOmg';
import NewProducts from '../../components/products/NewProducts';
import CompaignSection from '../../components/shared/CompaignSection';
import TodayHotDeal from '../../components/products/TodayHotDeal';
import CustomerTestimonial from '../../components/shared/CustomerTestimonial';
import PopularProducts from '../../components/products/PopularProducts';
import ContactBanner from '../../components/shared/ContactBanner';


const Home = () => {
    const navigate = useNavigate();
    const [siteTitle, setSiteTitle] = useState(Config['SITE_TTILE']);

    return (
        <>

            <Helmet>
                <title>Buy Uthukuli Butter Online {siteTitle} - Home</title>
               
        <meta name="description" content="Buy uthukuli butter online. We provide 100% pure white butter taken from buffalo/Cow milk cream from uthukuli. Buy now!"/>
        <meta name="robots" content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"/>

        <meta property="og:title" content="Buy Uthukuli Butter Online in Uklbutter.com"/>
        <meta property="og:description" content="Buy uthukuli butter online in Uklbutter.com. We provide 100% pure white butter taken from buffalo/Cow milk cream from uthukuli"/>
        <meta property="og:site_name" content=" Uklbutter.com"/>
        <meta name="keywords" content="uklbutter,  uthukuli butter, order butter, original butter"></meta>
            </Helmet>

            <div className="bg-light">
                <BannerSlider />
                <PopularCategories />
                <DiscountBannerOmg/>
                <NewProducts effect="icon-inline"/>
                <CompaignSection/>
                <TodayHotDeal/>
                <CustomerTestimonial/>
                <PopularProducts hoverEffect = "icon-inline"/>
                <ContactBanner/>
            </div>
        </>
    );

}

export default Home;


